<template>
<div class="chapter">
<div class="inner_page">
<div class="titlePage">
<p class="centerImage"><img alt="" src="Images/ImmelmannTitle.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?4b1a2bda